module.exports = __webpack_public_path__ + "static/media/angle-double-left.a430452a.svg";